import React from "react";
import clsx from "clsx";
import { IPSFacility } from "../../../models/peer-support";

type FacilityResourcesProps = {
	facility: IPSFacility;
	className?: string;
};

export const FacilityResources: React.FC<FacilityResourcesProps> = (props: FacilityResourcesProps) => {
	// if (!props.facility.resources || !props.facility.resources.length) return null;
	return (
		<ul className={clsx("checkmark-list", props.className)}>
			{(props.facility.resources || []).map((resource: string, i: number) => (
				<li key={i}>{resource}</li>
			))}
			{props.facility.workcomp && <li className={props.facility.workcomp}>Work Compensation</li>}
			{props.facility.telemedicine && <li className={props.facility.telemedicine}>Telemedicine</li>}
		</ul>
	);
};
